module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('Webheader.import_bank_account'),
      "iconF7": "list_bullet"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-2"
  }, [_c('div', {
    staticClass: "fileContainer"
  }, [_vm._v("\n          Choose file\n          "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": "file2",
      "id": "file2"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachmentName),
      expression: "attachmentName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "filename",
      "placeholder": "Choose file",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.attachmentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachmentName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2",
      "offset-md": "9"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.importAttachment
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "list_bullet"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Import")])], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cb989e5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb989e5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bankAccounts/CMImportBankAccount.vue
// module id = 2507
// module chunks = 2